module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Picks")]), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, [_c('li', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [(!_vm.user || !_vm.user.premium) ? _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7783278999",
      "ad-layout-key": "-8i+1w-dq+e9+ft",
      "ad-format": "fluid"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.picks), function(pick) {
    return _c('div', {
      staticClass: "article"
    }, [_c('a', {
      staticClass: "title_article",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(pick.title))]), _vm._v(" "), _c('p', {
      staticClass: "text_article",
      domProps: {
        "innerHTML": _vm._s(pick.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text_article_pick"
    }, [_c('b', {
      staticClass: "article_pick"
    }, [_vm._v(_vm._s(pick.pick))]), _vm._v("\n             \n          "), _c('b', {
      staticClass: "article_pick"
    }, [_vm._v(_vm._s(pick.side))]), _vm._v("\n             \n          "), _c('b', {
      staticClass: "article_pick"
    }, [_vm._v(_vm._s(pick.price))]), _vm._v("\n             \n          "), _c('b', {
      staticClass: "article_pick"
    }, [_vm._v(_vm._s(pick.units))]), _vm._v("\n           \n           "), _c('b', {
      staticClass: "article_pick"
    }, [_vm._v(_vm._s(pick.units == 1 ? 'unit' : 'units'))])])])
  }), _vm._v(" "), (_vm.picks && _vm.picks.length === 0) ? _c('p', [_vm._v("There are no picks currently posted. To receive picks immediately when they are posted, please set up pick notifications in the "), _c('router-link', {
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_vm._v("my account section (premium members only).")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 2)]), _vm._v(" "), (_vm.user && !_vm.user.premium) ? _c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "height": "20px"
    }
  }, [_vm._v("Buy Premium Picks")]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.user.premium) ? _c('ul', {
    staticClass: "articles"
  }, [_c('li', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [(_vm.allYear) ? _c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("1 Year All Sports Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n            Every single expert pick for 365 days! Only "), (_vm.allYear.current_price !== _vm.allYear.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.allYear.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.allYear.current_price) + ". Best Value!\n            "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allYear,
      "color": 'gold'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]), _vm._v(" "), _c('li', [(_vm.allMonth) ? _c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("1 Month All Sports Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n        Get our top rated plays. Every single expert pick for one month. Only "), (_vm.allMonth.current_price !== _vm.allMonth.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.allMonth.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.allMonth.current_price) + ".\n        "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allMonth,
      "color": 'gold'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]), _vm._v(" "), _c('li', [(_vm.allTwo) ? _c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("2 Weeks All Sports Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n      2 Weeks All Sports Package. Every single expert pick for 2 weeks. Only "), (_vm.allTwo.current_price !== _vm.allTwo.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.allTwo.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.allTwo.current_price) + ".\n      "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allTwo,
      "color": 'gold'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]), _vm._v(" "), _c('li', [(_vm.allWeek) ? _c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("1 Week All Sports Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n      1 Week All Sports Package. Every single expert pick for one week. Only "), (_vm.allWeek.current_price !== _vm.allWeek.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.allWeek.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.allWeek.current_price) + ".\n      "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allWeek,
      "color": 'gold'
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7783278999",
      "ad-layout-key": "-8i+1w-dq+e9+ft",
      "ad-format": "fluid"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51f40c2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Picks.vue
// module id = 285
// module chunks = 1